/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_DeleteInputs */

const vi_grower_area_delete = /** @type {(inputs: Grower_Area_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xoá vùng này`)
};

/**

* @param {Grower_Area_DeleteInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_delete = /** @type {((inputs?: Grower_Area_DeleteInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_DeleteInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_delete(inputs)
});